export default __webpack_public_path__ + "static/media/saint-laurent1.bec5da44.jpg";